exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#checkout_sidebar_mileage_modal_trigger[data-v-7ae95544] {\n  cursor: pointer;\n}", ""]);

// exports
